module.exports = __webpack_public_path__ + "static/media/axa_logo.547ea6c2.png";